module.exports = __webpack_public_path__ + "img/map_icon_my_location.fa0d0398.svg";